import * as React from 'react'

import { ButtonLarge } from '~ui/components/buttons/ButtonSizes/ButtonLarge'

import { useSubmitButtonLabel } from '../../../helpers/useSubmitButtonLabel'
import { useLockedOrderCtx } from '../contexts/LockedOrderProvider'
import { useSelectedPaymentMethodCtx } from '../contexts/OrderLockedPaymentMethodProvider'

type TProps = NoChildren & {
  isMobile: boolean
  onSubmitOrder: () => void
}

/**
 * Button that will handle the submit of the changed payment method.
 */
export const GoToPaymentButton: React.FC<TProps> = ({ isMobile, onSubmitOrder }) => {
  const paymentMethod = useSelectedPaymentMethodCtx()

  const order = useLockedOrderCtx()
  const isLoading = !order

  const label = useSubmitButtonLabel({ isMobile, paymentMethod })

  const onSubmit = () => {
    if (isLoading) {
      return
    }

    onSubmitOrder()
  }

  return (
    <ButtonLarge
      bgColor={`conversion`}
      onClick={onSubmit}
      state={isLoading ? `loading` : `enabled`}
    >
      {label}
    </ButtonLarge>
  )
}
